import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../config';

@Injectable({
  providedIn: 'root',
})
export class WebappService {
  constructor(private _http: HttpClient) {}

  firmaInfo(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'firmaInfo', a)
      .pipe(map((res: any) => res));
  }
}
